
import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { logError, logInfo } from "../../../Elasticsearchinstance";
import useAxiosPublic from "../../../Hooks/useAxiosPublic";


const EditQuestionBank = ({
  setEditModal,
  editModal,
  queid,
  Course,
  Skills,
  Level,
  Time,
  Questions,
  OptionA,
  OptionB,
  OptionC,
  OptionD,
  OptionE,
  Answer,
  Description,
  Status,
  QuestionType,
}) => {
  console.log(queid);
  console.log(Course);

  const axiousPublic = useAxiosPublic();

  // dynamic data ke lie
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [data, setData] = useState({
    queid: queid,
    Course: "",
    Skills: "",
    Questions: "",
    OptionA: "",
    OptionB: "",
    OptionC: "",
    OptionD: "",
    Answer: "",
    Description: "",
    Status: "",
    Time: "",
    OptionE: "",
    QuestionType: "",
    Level: "",
  });

  const inputEvent = (event) => {
    const { name, value, type, checked } = event.target;

    setData((preVal) => {
      return {
        ...preVal,
        [name]: type === "checkbox" ? selectedCheckboxes : value,
      };
    });
    if (type === "checkbox") {
      // Update the selected checkboxes array
      setSelectedCheckboxes((prevCheckboxes) => {
        if (checked) {
          return [...prevCheckboxes, value];
        } else {
          return prevCheckboxes.filter((checkbox) => checkbox !== value);
        }
      });
    }
  };
  const formSubmit = async (e) => {
    // alert("hello");
    e.preventDefault();
    const update_data = {
      queid: queid,
      Course: data.Course || Course,
      Skills: data.Skills || Skills,
      Questions: data.Questions || Questions,
      OptionA: data.OptionA || OptionA,
      OptionB: data.OptionB || OptionB,
      OptionC: data.OptionC || OptionC,
      OptionD: data.OptionD || OptionD,
      OptionE: data.OptionE || OptionE,
      Answer: data.Answer || Answer,
      Description: data.Description || Description,
      Status: data.Status || Status,
      Time: data.Time || Time,
      QuestionType: data.QuestionType || QuestionType,
      Level: data.Level || Level,
    };

    try {
      const res = await axiousPublic.put(`/updateQuestionBank`, update_data);
      console.log(res);
      // Log the successful update
      logInfo('Questions updated', update_data);
      alert("Questions Updated!");
      window.location.reload();
    } catch (error) {
      console.error("Error submitting question data:", error);
       // Log the error
       logError('Error submitting question data', error);
    }
  };

  const [quesType, setQuestionType] = useState(
    "Objective",
    "TrueFalse",
    "FillBlanks",
    "CheckBoxes",
    "Subjective"
  );
  const handleQuestionTypeChange = (type) => {
    setQuestionType(type);
  };

  return (
    <>
      <input type="checkbox" id="my_modal_9" className="modal-toggle" />
      <div className="modal" role="dialog">
        <div className="modal-box w-11/12 max-w-6xl">
          <form onSubmit={formSubmit}>
            <div className="col-start-1 col-end-7 w-full bg-base-100 shadow-xl">
              <label htmlFor="" className="text-3xl font-bold p-1">
                Update Question
              </label>
              <div className="card-body">
                <h2 className="card-title">Question Type</h2>
                <div className="md:flex gap-9">
                  <label className="cursor-pointer label justify-start gap-2 ">
                    <input
                      type="radio"
                      name="QuestionType"
                      value={"Objective" || QuestionType}
                      className="radio checked:bg-blue-500"
                      checked={quesType === "Objective"}
                      onChange={(e) => {
                        handleQuestionTypeChange("Objective");
                        inputEvent(e);
                      }}
                    />
                    <span className="label-text">Objective</span>
                  </label>

                  <label className="cursor-pointer label justify-start gap-2  ">
                    <input
                      type="radio"
                      name="QuestionType"
                      value={"TrueFalse" || QuestionType}
                      className="radio checked:bg-blue-500"
                      checked={quesType === "TrueFalse"}
                      onChange={(e) => {
                        handleQuestionTypeChange("TrueFalse");
                        inputEvent(e);
                      }}
                    />
                    <span className="label-text">True False</span>
                  </label>

                  <label className="cursor-pointer label justify-start gap-2  ">
                    <input
                      type="radio"
                      name="QuestionType"
                      value={"FillBlanks" || QuestionType}
                      className="radio checked:bg-blue-500"
                      checked={quesType === "FillBlanks"}
                      onChange={(e) => {
                        handleQuestionTypeChange("FillBlanks");
                        inputEvent(e);
                      }}
                      // checked
                    />
                    <span className="label-text">Fill in the Blanks</span>
                  </label>

                  <label className="cursor-pointer label justify-start gap-2  ">
                    <input
                      type="radio"
                      name="QuestionType"
                      value={"Subjective" || QuestionType}
                      className="radio checked:bg-blue-500"
                      checked={quesType === "Subjective"}
                      onChange={(e) => {
                        handleQuestionTypeChange("Subjective");
                        inputEvent(e);
                      }}
                    />
                    <span className="label-text">Subjective</span>
                  </label>

                  <label className="cursor-pointer label justify-start gap-2  ">
                    <input
                      type="radio"
                      name="QuestionType"
                      value={"CheckBoxes" || QuestionType}
                      className="radio checked:bg-blue-500"
                      checked={quesType === "CheckBoxes"}
                      onChange={(e) => {
                        handleQuestionTypeChange("CheckBoxes");
                        inputEvent(e);
                      }}
                    />
                    <span className="label-text">Check Boxes</span>
                  </label>
                </div>
              </div>
            </div>

            {/*  */}
            <div className="mt-3">
              <div className="text-2xl p-2 font-bold bg-primary text-center text-white rounded-t-xl">
                Question Table
              </div>
              <table className="table table-zebra ">
                <tbody className="items-center">
                  {/* row 2 */}
                  <tr className="">
                    <td>
                      <span className="label-text font-bold text-lg ">
                        Course
                      </span>
                    </td>
                    <td>
                      <select
                        name="Course"
                        value={data.Course || Course}
                        onChange={inputEvent}
                        className="select select-bordered text-black select-sm w-full max-w-md "
                      >
                        <option>Select Course</option>
                        <option value="Java Developer">Java Developer</option>
                        <option value="Node Js">Node Js</option>
                        <option value="React Js">React Js</option>
                        <option value="Angular Js">Angular Js</option>
                        <option value="Vue Js">Vue Js</option>
                        <option value="Php">Php</option>
                      </select>
                    </td>
                  </tr>

                  {/* row 4 */}
                  <tr className="">
                    <td>
                      <span className="label-text font-bold text-lg">
                        Skills
                      </span>
                    </td>
                    <td>
                      <select
                        name="Skills"
                        value={data.Skills || Skills}
                        onChange={inputEvent}
                        className="select select-bordered text-black select-sm w-full max-w-md"
                      >
                        <option>Select skills</option>
                        <option value="html">html</option>
                        <option value="css">css</option>
                        <option value="spring">spring</option>
                        <option value="javascript">javascript</option>
                        <option value="Php">Php</option>
                      </select>
                    </td>
                  </tr>
                  {/* row 4 */}
                  <tr className="">
                    <td>
                      <span className="label-text font-bold text-lg">
                        Level
                      </span>
                    </td>
                    <td>
                      <select
                        name="Level"
                        value={data.Level || Level}
                        onChange={inputEvent}
                        className="select select-bordered text-black select-sm w-full max-w-md"
                      >
                        <option>Select Level</option>
                        <option value="0-1 yrs">0-1 yrs</option>
                        <option value="1-2 yrs">1-2 yrs</option>
                        <option value="1-3 yrs">1-3 yrs</option>
                        <option value="0-4 yrs">0-4 yrs</option>
                        <option value="1-4 yrs">1-4 yrs</option>
                      </select>
                    </td>
                  </tr>
                  {/* row 4 */}
                  <tr className="">
                    <td>
                      <span className="label-text font-bold text-lg">Time</span>
                    </td>
                    <td>
                      <select
                        name="Time"
                        value={data.Time || Time}
                        onChange={inputEvent}
                        className="select select-bordered text-black select-sm w-full max-w-md"
                      >
                        <option value="">Select Time</option>
                        <option value="01:00">01:00 min</option>
                        <option value="02:00">02:00 min</option>
                        <option value="03:00">03:00 min</option>
                        <option value="04:00">04:00 min</option>
                        <option value="05:00">05:00 min</option>
                        <option value="06:00">06:00 min</option>
                        <option value="07:00">07:00 min</option>
                        <option value="08:00">08:00 min</option>
                        <option value="09:00">09:00 min</option>
                        <option value="10:00">10:00 min</option>
                      </select>
                    </td>
                  </tr>

                  {/* ----- 1. Obective start card -----*/}
                  {quesType === "Objective" && (
                    <>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Questions
                          </span>
                        </td>
                        <td>
                          <input
                            required
                            type="text"
                            name="Questions"
                            value={data.Questions || Questions}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-lg"
                          />
                        </td>
                      </tr>
                      {/* row 9  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option A
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionA"
                            value={data.OptionA || OptionA}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 10  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option B
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionB"
                            value={data.OptionB || OptionB}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 11  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option C
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionC"
                            value={data.OptionC || OptionC}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 12  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option D
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionD"
                            value={data.OptionD || OptionD}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Answer
                          </span>
                        </td>
                        <td>
                          {/* <select
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            className="select select-bordered text-black select-sm w-full max-w-md"
                          >
                            <option value="">Select Answer</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                          </select> */}
                          <input
                            type="text"
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                    </>
                  )}
                  {/* ----- 1. Obective end card----- */}

                  {/* ----- 2. True/False start card -----*/}
                  {quesType === "TrueFalse" && (
                    <>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Questions
                          </span>
                        </td>
                        <td>
                          <input
                            required
                            type="text"
                            name="Questions"
                            value={data.Questions || Questions}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-lg"
                          />
                        </td>
                      </tr>
                      {/* row 9  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            True
                          </span>
                        </td>
                        <td>
                          <input
                            type="radio"
                            name="radio-btn"
                            value={data.OptionA || OptionA}
                            onChange={inputEvent}
                            // placeholder="Type here"
                            className="radio radio-primary"
                          />
                        </td>
                      </tr>
                      {/* row 10  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            False
                          </span>
                        </td>
                        <td>
                          <input
                            type="radio"
                            name="radio-btn"
                            value={data.OptionB || OptionB}
                            onChange={inputEvent}
                            // placeholder="Type here"
                            className="radio radio-primary"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Answer
                          </span>
                        </td>
                        <td>
                          {/* <select
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            className="select select-bordered text-black select-sm w-full max-w-md"
                          >
                            <option value="">Select Answer</option>
                            <option value="1">1</option>
                            <option value="0">0</option>
                          </select> */}
                          <input
                            type="text"
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                    </>
                  )}
                  {/* ----- 2. True/False end card----- */}

                  {/* ----- 3. Fill Blanks start card -----*/}
                  {quesType === "FillBlanks" && (
                    <>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Questions
                          </span>
                        </td>
                        <td>
                          <input
                            required
                            type="text"
                            name="Questions"
                            value={data.Questions || Questions}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-lg"
                          />
                        </td>
                      </tr>
                      {/* row 9  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option A
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionA"
                            value={data.OptionA || OptionA}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 10  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option B
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionB"
                            value={data.OptionB || OptionB}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 11  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option C
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionC"
                            value={data.OptionC || OptionC}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 12  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option D
                          </span>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="OptionD"
                            value={data.OptionD || OptionD}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Answer
                          </span>
                        </td>
                        <td>
                          {/* <select
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            className="select select-bordered text-black select-sm w-full max-w-md"
                          >
                            <option value="">Select Answer</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                          </select> */}
                          <input
                            type="text"
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                    </>
                  )}
                  {/* ----- 1. Obective end card----- */}

                  {/* ----- 4. Subjective start card -----*/}
                  {quesType === "Subjective" && (
                    <>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Questions
                          </span>
                        </td>
                        <td>
                          <input
                            required
                            type="text"
                            name="Questions"
                            value={data.Questions || Questions}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-lg"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Answer
                          </span>
                        </td>
                        <td>
                          <textarea
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            placeholder="Answer"
                            className="textarea textarea-bordered textarea-lg w-full max-w-md"
                          ></textarea>
                        </td>
                      </tr>
                    </>
                  )}
                  {/* ----- 4. Subjective end card----- */}

                  {/* ----- 5. check boxes start card -----*/}
                  {quesType === "CheckBoxes" && (
                    <>
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Questions
                          </span>
                        </td>
                        <td>
                          <input
                            required
                            type="text"
                            name="Questions"
                            value={data.Questions || Questions}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-lg"
                          />
                        </td>
                      </tr>
                      {/* row 9  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option A
                          </span>
                        </td>
                        <td className="flex items-center gap-3">
                          <input
                            type="text"
                            name="OptionA"
                            value={data.OptionA || OptionA}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 10  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option B
                          </span>
                        </td>
                        <td className="flex items-center gap-3">
                          <input
                            type="text"
                            name="OptionB"
                            value={data.OptionB || OptionB}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 11  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option C
                          </span>
                        </td>
                        <td className="flex items-center gap-3">
                          <input
                            type="text"
                            name="OptionC"
                            value={data.OptionC || OptionC}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 12  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option D
                          </span>
                        </td>
                        <td className="flex items-center gap-3">
                          <input
                            type="text"
                            name="OptionD"
                            value={data.OptionD || OptionD}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>
                      {/* row 12  */}
                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Option E
                          </span>
                        </td>
                        <td className="flex items-center gap-3">
                          <input
                            type="text"
                            name="OptionE"
                            value={data.OptionE || OptionE}
                            onChange={inputEvent}
                            placeholder="Type here"
                            className="input input-bordered w-full max-w-md text-black input-sm"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <span className="label-text font-bold text-lg">
                            Answer
                          </span>
                        </td>
                        <td>
                          <textarea
                            name="Answer"
                            value={data.Answer || Answer}
                            onChange={inputEvent}
                            placeholder="Example: A,B  B,C  C,D"
                            className="textarea textarea-bordered textarea-lg w-full max-w-md"
                          ></textarea>
                        </td>
                      </tr>
                    </>
                  )}
                  {/* ----- 5. check boxes end card----- */}

                  {/* row 14  */}
                  <tr>
                    <td>
                      <span className="label-text font-bold text-lg">
                        Description
                      </span>
                    </td>
                    <td>
                      <input
                        type="text"
                        name="Description"
                        value={data.Description || Description}
                        onChange={inputEvent}
                        placeholder="Type here"
                        className="input input-bordered w-full max-w-md text-black input-sm"
                      />
                    </td>
                  </tr>
                  {/* row 15  */}
                  <tr>
                    <td>
                      <span className="label-text font-bold text-lg">
                        Status
                      </span>
                    </td>
                    <td>
                      <select
                        name="Status"
                        value={data.Status || Status}
                        onChange={inputEvent}
                        className="select select-bordered text-black select-sm w-full max-w-md"
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Pending">Pending</option>
                        <option value="Suspend">Suspend</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="flex ml-16 mt-9 gap-3 ">
                <button
                  type="submit"
                  className="btn btn-success font-bold text-white"
                >
                  Update Question
                </button>

                <form method="dialog">
                  <button
                    onClick={() => setEditModal(!editModal)}
                    className="btn btn-error font-bold text-white"
                  >
                    <span>
                      <RxCross2 className="text-lg" />
                    </span>
                    Cancel
                  </button>
                </form>
              </div>

              <div className="modal-action">
                <form method="dialog">
                  <button
                    onClick={() => setEditModal(!editModal)}
                    className="btn btn-sm btn-circle absolute right-2 top-2"
                  >
                    ✕
                  </button>
                </form>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditQuestionBank;
